var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52637 1.07692C4.25514 1.07692 1.60329 3.72878 1.60329 7C1.60329 10.2712 4.25514 12.9231 7.52637 12.9231C10.7976 12.9231 13.4494 10.2712 13.4494 7C13.4494 3.72878 10.7976 1.07692 7.52637 1.07692ZM0.526367 7C0.526367 3.13401 3.66037 0 7.52637 0C11.3924 0 14.5264 3.13401 14.5264 7C14.5264 10.866 11.3924 14 7.52637 14C3.66037 14 0.526367 10.866 0.526367 7ZM6.98791 4.12821C6.98791 3.83082 7.22899 3.58974 7.52637 3.58974H7.53355C7.83093 3.58974 8.07201 3.83082 8.07201 4.12821C8.07201 4.42559 7.83093 4.66667 7.53355 4.66667H7.52637C7.22899 4.66667 6.98791 4.42559 6.98791 4.12821ZM6.26996 6.28205C6.26996 5.98467 6.51103 5.74359 6.80842 5.74359H7.52637C7.82375 5.74359 8.06483 5.98467 8.06483 6.28205V9.33333H8.24432C8.5417 9.33333 8.78278 9.57441 8.78278 9.87179C8.78278 10.1692 8.5417 10.4103 8.24432 10.4103H7.52637C7.22898 10.4103 6.98791 10.1692 6.98791 9.87179V6.82051H6.80842C6.51103 6.82051 6.26996 6.57944 6.26996 6.28205Z",
    fill: "#5E6C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.fea89f05486349e47b76b2e2e88ca6fd.svg";
export { ForwardRef as ReactComponent };